import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classes from '../addScripts.module.scss';
import SelectWithSearch from '../../../../_common/Form/Selects/SelectWithSearch/SelectWithSearch';
import api from '../../../../../api/api';
import accountHelpers from '../../../../../utils/accountHelpers';

const info = [
  {
    name: 'Name',
    path: 'name',
    optionWidth: '20%',
  },
  {
    name: 'Group',
    path: 'group',
    optionWidth: '15%',
  },
  {
    name: 'Specialization',
    path: 'specialization',
    optionWidth: '15%',
  },
  {
    name: 'Phone number',
    path: 'phone',
    optionWidth: '15%',
  },
  {
    name: 'Address',
    path: 'address',
    optionWidth: '35%',
  },
];

let timeout;

const Physician = ({ physicianInfo, setPhysician, error }) => {
  const [physiciansList, setPhysiciansList] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(false);

  const searchPhysician = (value) => {
    setSearchValue(value);
    clearTimeout(timeout);

    setPhysiciansList([]);

    if (value.trim()) {
      setLoading(true);

      timeout = setTimeout(async () => {
        const { data: { data: { response } } } = await api.getPhysicians({
          name: value, userId: accountHelpers.getUser().id, limit: 50,
        });

        const physicians = response.map((physician) => ({
          ...physician,
          name: `${physician?.firstName} ${physician?.lastName}`,
          address: _.compact([physician?.addressStreet, physician?.addressCity, physician?.addressState, physician?.addressZipCode]).join(', '),
        }));

        setPhysiciansList(physicians);
        setLoading(false);
      }, 400);
    } else {
      setLoading(false);
    }
  };

  const selectPhysician = (path, option) => {
    setSearchValue('');
    setPhysiciansList([]);

    if (option) {
      setPhysician(path, option);
    }
  };

  return (
    <div className={classes.medication_wrapper}>
      <h4>Physician</h4>

      <SelectWithSearch
        label="Search"
        wrapperClassName={classes.medication_search}
        searchValue={searchValue}
        onChange={(value) => searchPhysician(value)}
        options={physiciansList}
        loading={loading}
        tableOption={info}
        clearValueAfterSelect
        error={error}
        optionKey=""
        onSelectOption={(option) => selectPhysician('Physician', option)}
      />

      {!!physicianInfo && (
      <table className={classes.table}>
        <thead>
          <tr>
            {info.map(({ name }) => (
              <th key={name}>{name}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          <tr>
            {info.map(({ path }) => (
              <td key={path}>{physicianInfo[path] || '-'}</td>
            ))}
          </tr>
        </tbody>
      </table>
      )}
    </div>
  );
};

Physician.propTypes = {
  physicianInfo: PropTypes.object,
  setPhysician: PropTypes.func.isRequired,
  error: PropTypes.string,
};

Physician.defaultProps = {
  physicianInfo: null,
  error: '',
};

export default Physician;
